import {ActivityConditionTypeTranslation} from "./activity-condition-type-translation";

export class ActivityConditionType {

  public id: string;
  public name: string;
  public sortOrder: number;
  public translations: ActivityConditionTypeTranslation[] = [];

}
